export { default as default } from './KitAnimatedLoader';
